// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3dqu6","footer":"ChangeClinic_footer__pPxCR"};